/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2013-2023 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */

/**
 * @namespace Phaser.Math.Easing
 */

module.exports = {

    Back: require('./back'),
    Bounce: require('./bounce'),
    Circular: require('./circular'),
    Cubic: require('./cubic'),
    Elastic: require('./elastic'),
    Expo: require('./expo'),
    Linear: require('./linear'),
    Quadratic: require('./quadratic'),
    Quartic: require('./quartic'),
    Quintic: require('./quintic'),
    Sine: require('./sine'),
    Stepped: require('./stepped')

};
